import React, { useEffect, useRef } from "react";
import { Formik, FormikProvider } from "formik";
import YearPicker from "../../../views/capture/form/YearPicker";

export default function TableProYearPicker({ value, onSubmit, disabled }) {
  const textFieldRef = useRef(null);

  const handleFormikChange = newValue => {
    if (onSubmit) {
      onSubmit(newValue);
    }
  };

  useEffect(() => {
    if (!disabled && textFieldRef.current) {
      const timer = setTimeout(() => {
        if (textFieldRef.current) {
          textFieldRef.current.click();
        }
      }, 100);

      return () => clearTimeout(timer);
    }
  }, [disabled]);

  return (
    <Formik initialValues={{ expirationYear: value || "" }} onSubmit={() => {}} enableReinitialize>
      {formikProps => (
        <FormikProvider
          value={{
            ...formikProps,
            setFieldValue: (field, val, shouldValidate) => {
              formikProps.setFieldValue(field, val, shouldValidate);
              if (field === "expirationYear") {
                handleFormikChange(val);
              }
            },
          }}
        >
          <div style={{ pointerEvents: disabled ? "none" : "auto" }}>
            <YearPicker
              name="expirationYear"
              label="Expiration Year"
              disabled={disabled}
              textFieldRef={textFieldRef}
            />
          </div>
        </FormikProvider>
      )}
    </Formik>
  );
}
